module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectItem":"Select item"},"es":{"selectItem":"Seleccionar elemento"}}')
  delete Component.options._Ctor
}
